import "./styles/index.css";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import AppContextProvider from "./contexts/AppContextProvider";
import { QueryClientProvider } from "react-query";
import AppRoutes from "./Routes";
import { queryClient } from "./lib/react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { FullPageSpinner } from "@components/Common/Spinner/FullPageSpinner";
import { SocketProvider } from "@utils/socket/socketContext";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import envConfig from "./environment";

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(envConfig.REACT_APP_STRIPE_PUBLISHABLE_KEY);


(async () => {
  const root = createRoot(document.getElementById("root"));

  const AppContent = (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<FullPageSpinner />}>
        <AppContextProvider>
          <SocketProvider>
            <Elements stripe={stripePromise}>
              <Router>
                <AppRoutes />
              </Router>
            </Elements>
          </SocketProvider>
          <ToastContainer />
        </AppContextProvider>
      </Suspense>
    </QueryClientProvider>
  );

  root.render(
    process.env.NODE_ENV === "development" ? (
      <React.StrictMode>{AppContent}</React.StrictMode>
    ) : (
      AppContent
    )
  );
})();
